import React from 'react'

//Node Modules
import { useTranslation } from 'react-i18next'

//Components
import { LockedIcon } from 'components/SASIcon'
import Checkbox from 'components/Checkbox'

//Styles
import styles from './Filters.module.scss'

//Types
import { FilterOption } from 'types/search'

interface Props {
  options: FilterOption[],
  selected: FilterOption[],
  setSelected: (option: FilterOption[])=>void
}

const Filters = ({options, selected, setSelected}:Props) => { 

  const { t } = useTranslation()

  const isSelected = (option: FilterOption):boolean => {
    if ( selected.length === options.length ) return false
    return selected.findIndex( s => {return s.value === option.value}) > -1 
  }

  const handleSelect = (e: React.ChangeEvent<HTMLInputElement>) => {
    //find selected option
    let selOption = options.find( o => {return o.value === e.currentTarget.value}) || null
    
    if (selOption) {
      //check to see if all selected
      if (options.length === selected.length) {
        setSelected([selOption])
      }
      //if option being removed
      else if (isSelected(selOption)) {
        let curr = JSON.parse(JSON.stringify(selected)) 
        curr.splice(selected.findIndex(s => {return s.value === selOption!.value}), 1)
        setSelected(curr) 
      } else {
        setSelected(selected.concat([selOption]))
      }
    }
  }

  const selectAll = () => {
    setSelected(options)
  } 

  const getLabel = (option: FilterOption) => {
    return <span>{`${option.display} `}</span>
  }

  return (
    <div className={styles.filterContainer}>
      <div className={styles.filterHeader}>
        <div>
          <h4>{t('helpcenter-gui-icu.search.filters.filter_results.label')}</h4>
        </div>
        <div className={styles.selectAllContainer}>
          <Checkbox id="filterSelectAll" onChange={selectAll} label={t('helpcenter-gui-icu.search.filters.select_all.label')} checked={selected.length === options.length}/>
        </div>
      </div>
      {
        options.map(option => {
          return option.value !== '' ? <div key={option.value} className={styles.filterItem}><Checkbox  id={option.value} checked={isSelected(option)} onChange={handleSelect} ellipseText={true} label={getLabel(option)} title={option.display}/>{option.locked ? <span className={styles.lockIcon}><LockedIcon /></span> : null}</div> :null
        })
      }
    </div>
  )
}

export default Filters